import { MatIconModule } from '@angular/material/icon';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, KeyValueDiffer, KeyValueDiffers, TemplateRef, Type, ViewChild, ViewEncapsulation } from '@angular/core';
import { FieldTypeConfig, FormlyConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import {MatTimepickerModule} from '@angular/material/timepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DatePipe } from '@angular/common';

interface TimePickerProps extends FormlyFieldProps {
    timepickerOptions?: Partial<{
      min?: any;
      max?:any;
      interval:any;
      matTimepickerTogglePosition?: 'suffix' | 'prefix';
      }>;
}

export interface FormlyTimepickerFieldConfig extends FormlyFieldConfig<TimePickerProps> {
    type: 'mat-timepicker' | Type<MatTimePickerTyComponent>;
}
@Component({
  selector: 'mat-timepicker-type',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone     : true,
  imports: [MatIconModule, FormlyModule,  MatInputModule,    ReactiveFormsModule,    MatFormFieldModule, MatTimepickerModule, DatePipe],
  template: `
    @if (formState.editMode) {
      <input
      matInput
      [id]="id"
      [name]="field.name"
      [matTimepicker]="picker"
      [readonly]="props.readonly"
      [required]="required"
      [errorStateMatcher]="errorStateMatcher"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [tabIndex]="props.tabindex"
      [matTimepickerMin]="props.timepickerOptions.min"
      [matTimepickerMax]="props.timepickerOptions.max"
      [placeholder]="props.placeholder">
      <ng-template #timepickerToggle >
      <mat-timepicker-toggle matIconSuffix [for]="picker"></mat-timepicker-toggle>
    </ng-template>
      <mat-timepicker
      [interval]="props.timepickerOptions.interval"
      #picker></mat-timepicker>
    }@else{
    {{field.formControl.value | date:'HH:mm'}}
    }
  `
})
export class MatTimePickerTyComponent extends FieldType<FieldTypeConfig<TimePickerProps>> {

    @ViewChild('timepickerToggle', { static: false }) timepickerToggle!: TemplateRef<any>;

         override defaultOptions = {
             props: {
               timepickerOptions: {
                matTimepickerTogglePosition: 'suffix' as const
               },
             },
           };




           private differ: KeyValueDiffer<string, any>;

         constructor(private config: FormlyConfig, private cdRef: ChangeDetectorRef,private differs: KeyValueDiffers) {
             super();
             this.differ = this.differs.find({}).create();
         }

        // per vedere se è cambiato il valore di editMode
         ngDoCheck() {
             const changes = this.differ.diff(this.field.options.formState);
             if (changes) {
               changes.forEachChangedItem(item => {
                 this.detectChanges();
                 if (item.key === 'editMode') {
                     if (item.currentValue){
                         this.props[this.props.timepickerOptions.matTimepickerTogglePosition] = this.timepickerToggle;
                     }
                     else{
                         this.props[this.props.timepickerOptions.matTimepickerTogglePosition]=null
                     }
                 }
               });
             }
         }


         detectChanges() {
          this.options.detectChanges?.(this.field);
          this.cdRef.detectChanges();
      }


      ngAfterViewInit() {
        if (this.field.options.formState.editMode){
            this.props[this.props.timepickerOptions.matTimepickerTogglePosition] = this.timepickerToggle;
        }
    }

}




